import React from "react";
import { Button } from "./ui/button";

const JourneySection = () => {
  // Journey images data - Using images from public/images/journey
  const journeyImages = [
    {
      name: "Unforgettable Moments",
      category: "LUXURY EXPERIENCE",
      image: "/images/journey/1_journey_lifetime.jpeg",
      description: "Create memories that will last forever in our extraordinary destinations."
    },
    {
      name: "Exceptional Service",
      category: "PERSONALIZED CARE",
      image: "/images/journey/2_journey_lifetime.jpeg",
      description: "Experience unparalleled hospitality crafted to exceed every expectation."
    },
    {
      name: "Timeless Elegance",
      category: "SOPHISTICATED LUXURY",
      image: "/images/journey/3_journey_lifetime.jpeg",
      description: "Immerse yourself in refined surroundings designed for the discerning traveler."
    },
    {
      name: "Transformative Adventures",
      category: "LIFE-CHANGING EXPERIENCES",
      image: "/images/journey/4_journey_lifetime.jpeg",
      description: "Embark on journeys that inspire and transform your perspective on luxury."
    }
  ];

  return (
    <section className="py-20" style={{ backgroundColor: 'black' }}>
      <div className="max-w-7xl mx-auto px-4 mb-16">
        
        {/* Two-Column Header Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Left Column - Big Two-Line Text */}
          <div>
            <h2 className="text-white leading-tight">
              <span 
                style={{
                  fontFamily: 'Caslon540Std, serif',
                  fontSize: '40px',
                  fontStyle: 'italic',
                  fontWeight: '500',
                  height: '44px',
                  flexBasis: '83.3333%',
                  display: 'block',
                  color: 'white'
                }}
              >
                The Journey
              </span>
              <span 
                style={{
                  fontFamily: 'Caslon540Std, serif',
                  fontSize: '3.75rem', // --t-display-s-font-size-viewport-l
                  lineHeight: '4.125rem', // --t-display-s-line-height-viewport-l
                  fontWeight: '400', // --t-display-s-font-weight
                  letterSpacing: '0', // --t-display-s-letter-space
                  fontStyle: 'normal', // --t-display-s-font-style
                  textTransform: 'uppercase', // --t-display-s-text-transform
                  color: 'white',
                  display: 'block'
                }}
              >
                Of a Lifetime
              </span>
            </h2>
          </div>

          {/* Right Column - Paragraph and Button */}
          <div className="space-y-6">
            <p className="text-lg text-gray-300 leading-relaxed">
              Let The Ritz-Carlton take you to the ends of the earth. Discover distinctive resorts in the world's rarest escapes through Ritz-Carlton Reserve, where immersive experiences and unspoiled natural splendor forge lasting connections.
            </p>
            
            <Button
              className="bg-white text-black hover:bg-gray-200 px-8 py-3 text-sm font-medium transition-colors duration-200 rounded-none"
              style={{ 
                fontFamily: 'Swiss-721, Arial, sans-serif',
                fontSize: '0.8125rem',
                fontWeight: 700,
                letterSpacing: '0.5px'
              }}
            >
              Explore Ritz-Carlton Reserve
            </Button>
          </div>
        </div>
      </div>

      {/* 4-Column Grid */}
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {journeyImages.map((item, index) => (
            <div key={index} className="relative overflow-hidden group cursor-pointer">
              <img
                src={item.image}
                alt={item.name}
                className="w-full h-[433px] object-cover transition-transform duration-500 group-hover:scale-105"
                style={{ aspectRatio: '649/433' }}
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 text-white">
                <span className="inline-block text-[10px] tracking-[1.2px] mb-2 bg-white/90 text-black px-2 py-1 rounded-sm font-medium">
                  {item.category}
                </span>
                <h3 className="text-sm font-semibold leading-tight drop-shadow-lg mb-2">
                  {item.name}
                </h3>
                <p className="text-xs text-gray-200 leading-relaxed drop-shadow">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JourneySection;
